export default __webpack_public_path__ + "static/media/pending.31ec38a5.svg";